import React from 'react';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';
import styles from './UpdateAvailableBanner.module.css';

const UpdateAvailableBanner = (): React.ReactElement | null => {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className={styles['update-available-banner']}>
      <div className={styles['update-banner-content']}>
        <span className={styles['update-icon']}>🔄</span>

        <div className={styles['update-text']}>
          A new version of HallHero is available.
        </div>

        <div className={styles['update-banner-actions']}>
          <button className={styles['refresh-button']} onClick={applyUpdate}>
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateAvailableBanner;
